import { DataSource, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentGroupWarnings extends Layout {
    imagePreassignmentErrors: Image;
    labelDoublesCertWarning: Label;
    labelDriverProhibited: Label;
    labelEquipmentRequirements: Label;
    labelEquipmentWarning: Label;
    labelMaintenanceWarningTitle: Label;
    labelPreassignmentErrors: Label;
    labelSaveWarning: Label;
    panelDoublesCertificationWarnings: Panel;
    panelDriverOne: Panel;
    panelDriverTwo: Panel;
    panelEquipmentIssuedWarnings: Panel;
    panelMaintenanceWarnings: Panel;
    panelProhibitedDrivers: Panel;
    panelRegulatoryRequirements: Panel;
    panelWarningsDouble: Panel;
    panelWarningsEquipment: Panel;
    panelWarningsMaintenance: Panel;
    panelWarningsRegulatory: Panel;
    sourceEquipmentGroupWarning: DataSource;
    textboxDriverOneCustomer: Textbox;
    textboxDriverOneLocation: Textbox;
    textboxDriverOneName: Textbox;
    textboxDriverTwoCustomer: Textbox;
    textboxDriverTwoLocation: Textbox;
    textboxDriverTwoName: Textbox;
}
